<template>
  <div>
    <p>
      <em class="fa fa-clock color-primary-2" />
      <b class="ml-2">Historial de Documentos</b>
    </p>

    <custom-result-not-found v-if="history.length === 0" />

    <time-line>
      <div v-for="(item, index) in history" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <em class="fas fa-file radius color-white" />
          </template>

          <template #date>
            <div class="date-container">
              <div class="font-12">Fecha</div>
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.createdDateTime | date }}
              </div>
              <div class="color-black font-12 font-weight-normal hour">
                {{ item.createdDateTime | hour }}
              </div>
            </div>
          </template>

          <div class="row py-4 mx-3">
            <div class="col-md-4">
              <div class="d-flex align-items-center">
                <em
                  class="fas fa-circle mr-2 font-12"
                  :style="{ color: resolveColor(item.statusId) }"
                />
                <div class="color-black font-16 font-weight-normal">
                  {{ item.statusName }}
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="color-gray-6 font-14 font-weight-normal">
                Nombre del Usuario
              </div>
              <div class="color-black font-16 font-weight-normal">
                {{ item.creatororName }}
              </div>
            </div>

            <div class="col-md-4">
              <div class="color-gray-6 font-14 font-weight-normal">
                Nombre del archivo:
              </div>
              <div class="color-black font-16 font-weight-normal">
                {{ item.filename }}
              </div>
            </div>

            <div
              v-if="item.comment"
              class="col-md-12 p-2 mt-3 comment__container"
            >
              <p>
                <em class="fas fa-info-circle color-primary-2" />
                <b class="ml-2">Comentario</b>
              </p>
              <span class="ml-2">{{ item.comment }}</span>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import { resolveColorHexa } from '@/views/provider/proposalHistory/components/proposalDocumentStatus.js';

export default {
  name: 'ContractDocumentStatusHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
  },
  props: {
    history: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({}),
  computed: {},
  watch: {},
  async mounted() {
    this.$emit('fetch-history');
  },
  methods: {
    resolveColor(statusId) {
      return resolveColorHexa(statusId);
    },
  },
};
</script>

<style scoped lang="scss">
.date-container {
  text-align: end;
}

.comment__container {
  background-color: white;
  border-radius: 3px;
}

::v-deep .timeline__content::before {
  height: calc(100% + 30px) !important;
  top: 15px !important;
}

::v-deep .timeline__content::after {
  top: 15px !important;
}

::v-deep .custom-time-line {
  .timeline__content--inner {
    padding: unset !important;
  }
}
</style>
